"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconClass = exports.IconName = void 0;
var IconName = /*#__PURE__*/function (IconName) {
  IconName["CANCEL"] = "alert-report-filled";
  IconName["WARNING"] = "alert-warning-filled";
  IconName["CHECK"] = "sign-circled-check";
  IconName["INFO"] = "alert-info-filled";
  return IconName;
}(IconName || (exports.IconName = IconName = {}));
var IconClass = /*#__PURE__*/function (IconClass) {
  IconClass["CANCEL"] = "cancel-icon";
  IconClass["WARNING"] = "warning-icon";
  IconClass["SUCCESS"] = "success-icon";
  IconClass["INFO"] = "info-icon";
  return IconClass;
}(IconClass || (exports.IconClass = IconClass = {}));

